import { render, staticRenderFns } from "./GalleryPreview.vue?vue&type=template&id=5db7c7ba"
import script from "./GalleryPreview.vue?vue&type=script&lang=js"
export * from "./GalleryPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db7c7ba')) {
      api.createRecord('5db7c7ba', component.options)
    } else {
      api.reload('5db7c7ba', component.options)
    }
    module.hot.accept("./GalleryPreview.vue?vue&type=template&id=5db7c7ba", function () {
      api.rerender('5db7c7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/community/GalleryPreview.vue"
export default component.exports